export const defaultColors = [
  ['#000000', '#545454', '#737373', '#a6a6a6', '#d9d9d9', '#ffffff'],
  ['#ff3131', '#FF5757', '#FF66C4', '#CB6CE6', '#8C52FF', '#5E17EB'],
  ['#0097B2', '#0CC0DF', '#5CE1E6', '#38B6FF', '#5271FF', '#004AAD'],
  ['#00BF62', '#7ED957', '#C1FF72', '#FFDE59', '#FFBD59', '#FF914D'],
];
